import { styled } from "@mui/system";

export const Wrapper = styled("video")(({ maxHeight }) => ({
  height: "auto",
  maxHeight: maxHeight,
  width: "100%",
  borderRadius: "15px",
}));
